import React from "react";
import { BadgeTypes } from "@siteimprove/fancylib";

export type MainNavigationItem = (BaseNavigationItem | LinkItem | ButtonItem) & {
	icon: React.ReactElement | null;
	children?: SubNavigationItem[];
	groups?: GroupType[];
};

export type GroupType = {
	id: string;
	title: string;
	order: number;
};

export type SubNavigationItem = (BaseNavigationItem | LinkItem | ButtonItem) & {
	icon: React.ReactElement | null;
	groupId?: string;
	children?: SubNestedNavigationItem[];
};

export type SubNestedNavigationItem = (BaseNavigationItem | LinkItem | ButtonItem) & {
	children?: SubNestedNavigationItem[];
};

export type BaseNavigationItem = {
	id: string;
	title: string;
	defaultChildId?: string | null;
	observeKey?: string;
	labels?: ItemLabel[];
	visible?: boolean;
};

export type LinkItem = {
	href: string;
	openNew?: boolean;
	onClick?: () => void | Promise<void>;
} & BaseNavigationItem;

export type ButtonItem = {
	onClick: () => void | Promise<void>;
} & BaseNavigationItem;

export type ItemLabel = {
	type: BadgeTypes;
	icon?: JSX.Element;
	text?: string;
	tooltip?: string;
};

export function isLinkItem(
	item: MainNavigationItem | SubNavigationItem | SubNestedNavigationItem
): item is LinkItem {
	return "href" in item;
}

export function isButtonItem(
	item: MainNavigationItem | SubNavigationItem | SubNestedNavigationItem
): item is ButtonItem {
	return "onClick" in item;
}

export type NavigateFn<EventType> = (
	item: MainNavigationItem | SubNavigationItem | SubNestedNavigationItem,
	e: EventType
) => void;
